
import { mapGetters, mapActions } from 'vuex';
import { effectSlider }  from '../constants/config.js';
export default {
	head: {
        link: [
            {
                rel: 'preload',
                as: 'image',
                href: '/images/animated-secuence/home-banner/banner-animated-secuence-01_420.webp',
                type: 'image/webp',
                imagesrcset: '/images/animated-secuence/home-banner/banner-animated-secuence-01_213.webp 213w, /images/animated-secuence/home-banner/banner-animated-secuence-01_280.webp 280w, /images/animated-secuence/home-banner/banner-animated-secuence-01_420.webp 420w, /images/animated-secuence/home-banner/banner-animated-secuence-01_560.webp 560w',
                imagesizes: '(max-width: 480px) 213px, (max-width: 768px) 280px, (min-width: 769px) 420px'
            },
            { rel: 'preload', as: 'image', href: '/images/background-mural.webp', type: 'image/webp' }
        ]
    },
	components: {
		bannerAnimated	    : () => import('../components/home/banner-animated.vue'),
		// sliderVideo			: () => import('../components/home/slider-video.vue'),
		productCollection	: () => import('../components/product/product-collection.vue'),
		logoSlider			: () => import('../components/home/logo-slider.vue'),
		faq					: () => import('../components/account/faq.vue'),
		vcDynamicLink		: () => import('../components/pages/dynamic-link.vue'),
		testimonial			: () => import('../components/home/testimonial.vue'), 
	},
	data() {
		return {
			isLoading					: true,
			collection_products			: [],
			cateogry_product_image_1    : {
                src     : '/images/product-category-mural/product-category-jeans_300.webp',
                sizes   : '(max-width: 990px) 50vw, (max-width: 1023px) 33.33vw, (max-width: 1429px) 25vw, (max-width: 1679px) 350px, (max-width: 1919px) 400px, (max-width: 2559px) 475px, 500px',
                srcset  : [
                '/images/product-category-mural/product-category-jeans_256.webp 256w',
                '/images/product-category-mural/product-category-jeans_300.webp 300w',
                '/images/product-category-mural/product-category-jeans_350.webp 350w',
                '/images/product-category-mural/product-category-jeans_400.webp 400w',
                '/images/product-category-mural/product-category-jeans_475.webp 475w',
                '/images/product-category-mural/product-category-jeans_520.webp 520w',
                '/images/product-category-mural/product-category-jeans_700.webp 700w',
                '/images/product-category-mural/product-category-jeans_900.webp 900w'
                ],
                alt: 'Top-rated wholesale compression garments for retailers​'
            },
            cateogry_product_image_2    : {
                src     : '/images/product-category-mural/product-category-shapewear_300.webp',
                sizes   : '(max-width: 990px) 50vw, (max-width: 1023px) 33.33vw, (max-width: 1429px) 25vw, (max-width: 1679px) 350px, (max-width: 1919px) 400px, (max-width: 2559px) 475px, 500px',
                srcset  : [
                '/images/product-category-mural/product-category-shapewear_256.webp 256w',
                '/images/product-category-mural/product-category-shapewear_300.webp 300w',
                '/images/product-category-mural/product-category-shapewear_350.webp 350w',
                '/images/product-category-mural/product-category-shapewear_400.webp 400w',
                '/images/product-category-mural/product-category-shapewear_475.webp 475w',
                '/images/product-category-mural/product-category-shapewear_520.webp 520w',
                '/images/product-category-mural/product-category-shapewear_700.webp 700w',
                '/images/product-category-mural/product-category-shapewear_900.webp 900w'
                ],
                alt: 'Latest trends in wholesale fashion shapewear for B2B buyers​'
            },
            cateogry_product_image_3    : {
                src     : '/images/product-category-mural/product-category-underwear_300.webp',
                sizes   : '(max-width: 990px) 50vw, (max-width: 1023px) 33.33vw, (max-width: 1429px) 25vw, (max-width: 1679px) 350px, (max-width: 1919px) 400px, (max-width: 2559px) 475px, 500px',
                srcset  : [
                '/images/product-category-mural/product-category-underwear_256.webp 256w',
                '/images/product-category-mural/product-category-underwear_300.webp 300w',
                '/images/product-category-mural/product-category-underwear_350.webp 350w',
                '/images/product-category-mural/product-category-underwear_400.webp 400w',
                '/images/product-category-mural/product-category-underwear_475.webp 475w',
                '/images/product-category-mural/product-category-underwear_520.webp 520w',
                '/images/product-category-mural/product-category-underwear_700.webp 700w',
                '/images/product-category-mural/product-category-underwear_900.webp 900w'
                ],
                alt: 'Enhance your inventory with our wholesale shapewear for US distributors'
            },
            cateogry_product_image_4    : {
                src     : '/images/product-category-mural/product-category-accessories_300.webp',
                sizes   : '(max-width: 990px) 50vw, (max-width: 1023px) 33.33vw, (max-width: 1429px) 25vw, (max-width: 1679px) 350px, (max-width: 1919px) 400px, (max-width: 2559px) 475px, 500px',
                srcset  : [
                '/images/product-category-mural/product-category-accessories_256.webp 256w',
                '/images/product-category-mural/product-category-accessories_300.webp 300w',
                '/images/product-category-mural/product-category-accessories_350.webp 350w',
                '/images/product-category-mural/product-category-accessories_400.webp 400w',
                '/images/product-category-mural/product-category-accessories_475.webp 475w',
                '/images/product-category-mural/product-category-accessories_520.webp 520w',
                '/images/product-category-mural/product-category-accessories_700.webp 700w',
                '/images/product-category-mural/product-category-accessories_900.webp 900w'
                ],
                alt: 'Effective body shaping with our wholesale compression wear​'
            },
			swipper_products_categories: {
                slidesPerView: 2,
                spaceBetween: 0,
                loop: false,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4
                    },
                    991: {
                        slidesPerView: 3
                    },
                    768: {
                        slidesPerView: 2
                    },
                    640: {
                        slidesPerView: 2
                    }
                }
            },
			cateogry_product_image_sizes: [
				"xs:180px",
				"sm:250px",
				"md:400px",
				"lg:280px",
				"xl:320px",
				"2xl:350px"
            ],
		}
	},
	async mounted() {
		window.addEventListener('load', this.loadPage);
		
		await this.getCollectionHome();
	},
	computed: {
		...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang: 'getterStoreLang',
			getterCollectionHome: 'getterCollectionHome',
			getterBasicData: 'getterBasicData'
		}),
		getterCallPhone(){
			return this.getterBasicData?.contact_information.phones.find( (item) => item.call );
		}
	},
	methods: {
		...mapActions({
			getCollectionHome: 'getCollectionHome'
		}),
		loadPage(event){
			setInterval(() => {
				if( this.getterCollectionHome ){
					
					effectSlider('slider-top-products', this.getterCollectionHome.length, 1500 );
				}
				effectSlider('slider-services', 4, 1500 );
				effectSlider('slider-benefits', 4, 1500 );
				effectSlider('slider-first-order', 2, 1500 );
			}, 3000);
		}
	}
}
